import { useEffect, useState } from 'react';
import Footer from '../Footer';
import Header from '../Header';

export default function InnerPage(props) {
  const { title, children } = props;
  const [todayDate, setTodayDate] = useState('');

  useEffect(() => {
    const currentTime = new Date().toISOString();
    setTodayDate(currentTime);
  }, []);
  return (
    <div className="inner_page">
      <div className="header__wrapper">
        <Header />
        {/* {todayDate} */}
        <div className="container mt-5 pt-5 pb-3">
          <h1 className="title">{title}</h1>
        </div>
      </div>
      <main className="py-5">{children}</main>
      <Footer />
    </div>
  );
}
